
    import Vue from "vue";
    import Component from "vue-class-component";
    import { Prop } from "vue-property-decorator";
    import { BriefingProgress } from "@/model/BriefingProgress";

    @Component({})
    export default class BriefingProgressIcons extends Vue {

        @Prop({ required: true })
        progress!: BriefingProgress;

        iconForPageNumber(n: number) {
            const index = n - 1;
            return this.progress.isQuizPage(index) ? "mdi-head-question-outline" : "mdi-comment-text-outline" ;
        }

        roundelCssClass(n: number): string {
            const index = n - 1;
            return this.progress.isFuturePage(index) ? "progress-roundel grey-roundel" : "progress-roundel";
        }
    }
